import { useRef, useState } from "react";
import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import {
  AsyncTypeahead,
  Typeahead,
  Highlighter,
} from "react-bootstrap-typeahead";
import patientService from "../services/patient.service";
import Calendar from "../shared/Calendar";
import { calendarEvents } from "../shared/data";
import { parseEvent } from "../Helper";
const AppointmentBooking = ({ onSelect, branches }) => {
  const bookingRef = useRef([]);
  const [typeAheadSelection, setTypeAheadSelection] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [branch, setBranch] = useState({});
  const handleSearch = async (query) => {
    try {
      // Make your API request here to fetch options based on the query
      const data = await patientService.searchService(query);
      if (data === false) throw new Error("Something went wrong");

      setTypeAheadSelection(data);
      return data;
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleSymptomItemSelect = (selectedItem) => {
    setTypeAheadSelection((prevState) => selectedItem);
  };
  const setNewEvents = async () => {
    if (typeAheadSelection.length === 0) return;
    const serviceEvents = await patientService.getBranchServiceSchedule(
      typeAheadSelection[0].bp_br_service_pricing_id,
      branch.bp_branch_id
    );
    const myCalendar = bookingRef.current["calendar"].getApi();
    myCalendar.removeAllEvents();
    myCalendar?.addEventSource(parseEvent(serviceEvents));
    setSelectedEvent(null);
    // setEvents(calendarEvents);
  };

  async function handleSelect() {
    if (selectedEvent) {
      const data = {
        ...selectedEvent.event.extendedProps,
        allDay: selectedEvent.event.allDay,
        end: selectedEvent.event.end,
        endStr: selectedEvent.event.endStr,
        groupId: selectedEvent.event.groupId,
        id: selectedEvent.event.id,
        start: selectedEvent.event.start,
        startStr: selectedEvent.event.startStr,
        title: selectedEvent.event.title,
        url: selectedEvent.event.url,
        bp_br_id: branch.bp_branch_id,
      };
      // onSelect(data);
      // console.log(data);
      onSelect instanceof Function && (await onSelect(data));
    }
  }
  function handleEventClick(info) {
    // info.event.setProp("backgroundColor", "green");
    info.el.style.backgroundColor = "lightblue";
    info.el.style.borderColor = "blue";
    // info.el.style.color = "white";
    const prevEvent = selectedEvent;
    if (prevEvent && prevEvent != info) {
      prevEvent.el.style.backgroundColor = "lightgray";
      prevEvent.el.style.borderColor = "gray";
      //   prevEvent.el.style.color = "black";
      //   console.log(info, info.event);
    }
    // const calendarApi = info.event?._context.calendarApi;
    // const updatedEvents = info.event ? [...calendarApi.getEvents()] : [];

    //   updatedEvents.forEach((event) => {
    //   //   if () {
    //   //     // Change the text color to red (you can replace it with your desired color)
    //   //     event.setProp("backgroundColor", "green");
    //   //   }
    //   const isSelected =
    //     event._instance.instanceId === info.event._instance.instanceId;
    //   info.el.style.backgroundColor = isSelected ? "lightblue" : "lightgray";
    //   info.el.style.borderColor = isSelected ? "blue" : "gray";
    //   info.el.style.color = isSelected ? "white" : "black";
    // });
    setSelectedEvent(info);
  }
  return (
    <>
      <Row md={1} lg={2}>
        <Col>
          <Form.Group className="mb-3">
            <Typeahead
              options={branches}
              placeholder="Select Branch"
              id="branch"
              labelKey={"bp_branch_name"}
              multiple={false}
              inputProps={{ required: true }}
              filterBy={() => true}
              // selected={[branch]}
              onChange={(s) =>
                setBranch({
                  ...s[0],
                })
              }
            ></Typeahead>
          </Form.Group>
        </Col>
        <Col>
          <InputGroup className="mb-3">
            <AsyncTypeahead
              renderMenuItemChildren={(option, { text }) => (
                <>
                  <Highlighter search={text}>
                    {option.bp_service_name}
                  </Highlighter>
                  <div>
                    <small>
                      {option.bp_name}&mdash;{option.bp_branch_name}
                      &mdash;
                      {option.currency} {option.rate}
                    </small>
                  </div>
                </>
              )}
              id="serviceTypeAhead"
              labelKey="bp_service_name"
              multiple={false}
              options={typeAheadSelection}
              onSearch={handleSearch}
              onChange={handleSymptomItemSelect}
              placeholder="Search..."
              inputProps={{ required: true }}
              ref={(el) => (bookingRef.current["search"] = el)}
              clearButton
            />
            <Button variant="outline-secondary" onClick={() => setNewEvents()}>
              Check Availibility
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row md={1} lg={2}>
        <Col>
          <Calendar
            initialEvents={events}
            calendarRef={(el) => (bookingRef.current["calendar"] = el)}
            eventClick={handleEventClick}
          />
        </Col>
        <Col>
          {!selectedEvent && (
            <>
              <div className="d-flex align-items-center h-100 my-3 w-100 justify-content-center">
                <h4 className="text-muted">Select an event</h4>
              </div>
            </>
          )}
          {selectedEvent && (
            <>
              <div className="card my-3 h-100">
                <div className="card-body d-flex align-items-center justify-content-center">
                  <div className="text-center">
                    <h4 className="card-title fst-italic">
                      {selectedEvent.event.start.toLocaleDateString()}
                    </h4>
                    <h5 className="card-title">{selectedEvent.event.title}</h5>
                    <p className="card-text">
                      Timing :{" "}
                      <span className="fst-italic">
                        {selectedEvent.event.start.toLocaleTimeString()} -{" "}
                        {selectedEvent.event.end.toLocaleTimeString()}
                      </span>
                    </p>
                    <p className="card-text">
                      Maximum Booking Allowed :{" "}
                      {selectedEvent.event.extendedProps.max_booking ||
                        "Unlimited"}
                    </p>
                  </div>
                </div>
                <div className="card-footer d-flex justify-content-between">
                  <div className="d-flex">
                    <small className=" fst-italic text-muted align-self-center">
                      {new Date(
                        selectedEvent.event.extendedProps.effective_from_date
                      ).toLocaleDateString()}{" "}
                      -{" "}
                      {new Date(
                        selectedEvent.event.extendedProps.effective_to_date
                      ).toLocaleDateString()}
                    </small>
                  </div>
                  <Button type="button" onClick={handleSelect}>
                    Select
                  </Button>
                </div>
              </div>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default AppointmentBooking;
